import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
export var HumanizedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(HumanizedError, _Error);

  function HumanizedError() {
    return _Error.apply(this, arguments) || this;
  }

  _createClass(HumanizedError, [{
    key: "humanMessage",
    get: function get() {
      return this.message;
    }
  }]);

  return HumanizedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var FatalComponentError = /*#__PURE__*/function (_HumanizedError) {
  _inheritsLoose(FatalComponentError, _HumanizedError);

  function FatalComponentError() {
    return _HumanizedError.apply(this, arguments) || this;
  }

  return FatalComponentError;
}(HumanizedError);
export var BadAttributeError = /*#__PURE__*/function (_HumanizedError2) {
  _inheritsLoose(BadAttributeError, _HumanizedError2);

  function BadAttributeError() {
    return _HumanizedError2.apply(this, arguments) || this;
  }

  return BadAttributeError;
}(HumanizedError);